import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Grid, G } from 'nallian-shared-ui/lib/components';
import HostField from './HostField';

const HostsFields = ({ fields, submitting }) => {
  const { t } = useTranslation();

  const handleAddFieldClick = useCallback(() => fields.push({ isPrimary: false }), [fields]);
  const handleRemoveFieldClick = useCallback((_, { i }) => fields.remove(i), [fields]);

  return (
    <Flex fluid direction="column">
      <Grid stackable>
        <G.Row columns={2}>
          {fields.map((f, index) => (
            <HostField
              index={index}
              fields={fields}
              field={f}
              key={`host_${index.toString()}`}
              handleRemoveFieldClick={handleRemoveFieldClick}
              submitting={submitting}
            />
          ))}
        </G.Row>
      </Grid>
      <Flex fluid margin="1rem 0 0 0">
        <Button
          linkbutton
          icon="add"
          type="button"
          tabindex="-1"
          content={t('addHost')}
          onClick={handleAddFieldClick}
        />
      </Flex>
    </Flex>
  );
};

HostsFields.propTypes = {
  fields: PropTypes.array.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default HostsFields;
